export enum PostPendingTransactionTypes {
    AddStock = 1,
    ReturnStock = 2
}
